import React, {useState} from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import {Delete, Email, Sms} from '@mui/icons-material'
import Confirmation from 'components/Confirmation'
import Dialog from 'components/Dialog'

const Row = styled.div`
    color: ${props => props.select ? '#415dd4' : ''};
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px;

    :hover {
        background: rgb(240, 240, 240);
    }
`

const Name = styled.span`
    font-weight: bold;
    margin: 0 10px;
`

const DeleteIcon = styled(Delete)`
    color: #d45b4a;
    cursor: pointer;
    margin-left: auto;
    font-size: 25px;
`

const Feedbacks = ({intl, keys, feedback, entityId, permissions, setFeedback, handleClose, deleteKey}) => {
	const [open, setOpen] = useState(null)

    const onClick = (id) => {
        setFeedback(id)
        handleClose()
    }

    const handleDelete = () => {
        if (feedback && feedback.id === open) {
            setFeedback(null)
        }

        deleteKey(open, entityId)
        onClose()

        if (keys.length === 1) {
            handleClose()
        }
    }

    const onDelete = (e, id) => {
        e.stopPropagation()
        setOpen(id)
    }

    const onClose = () => {
        setOpen(null)
    }

	return (
		<React.Fragment>
			<DialogTitle>
				{intl.formatMessage({id: "feedback.show_feedback"})}
			</DialogTitle>
			<DialogContent>
				{keys.map(item =>
					<Row key={item.id} select={feedback && feedback.id === item.id} onClick={() => onClick(item.id)}>
						{item.service === 'email' ? <Email /> : <Sms />}
						<Name>{item.name}</Name> {item.period}
						{permissions.Designer &&
							<DeleteIcon onClick={(e) => onDelete(e, item.id)} />
						}
					</Row>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="primary">
					{intl.formatMessage({id: "app.confirm_cancel"})}
				</Button>
				{feedback &&
					<Button onClick={() => onClick(null)} color="secondary" variant="contained">
						{intl.formatMessage({id: "feedback.clear"})}
					</Button>
				}
			</DialogActions>
			{open &&
				<Dialog
					open={true}
					onClose={onClose}
				>
					<Confirmation
						text={intl.formatMessage({id: "feedback.confirm_delete_key_text"}, {
							name: keys.find(item => item.id === open).name})}
						handleClose={onClose}
						handleConfirm={handleDelete}
					/>
				</Dialog>
			}
		</React.Fragment>
	)
}

export default injectIntl(Feedbacks)
